<template>
   <div class="contenedor_modal_completo">
      <div class="contenedor_modal_completo_cabecera">
         <button type="button" class="btn btn-sm btn-outline-danger" v-shortkey="['esc']" @shortkey="cerrar"
            @click="cerrar">
            Cerrar
         </button>
      </div>
      <div class="contenedor_modal_completo_contenido">
         <b-container>
            <b-row>
               <div class="col-sm-12 mt-3">
                  <h3>
                     Certificación de contingencia
                  </h3>
               </div>
               <div class="col-sm-10 mt-3">
                  <label for="" class="form-label">
                     Código de contingencia
                  </label>
                  <input type="text" id="campo_codigo_contigencia" class="form-control form-control-sm"
                     v-model="codigo">
               </div>
               <div class="col-sm-2 mt-5">
                  <button type="buttton" class="btn btn-sm btn-outline-dark btn-block"
                     @click="registros_de_contingencias">Buscar</button>
               </div>
               <div class="col-sm-12 mt-3">
                  <h3>
                     {{ cta }}
                  </h3>
               </div>
               <div class="col-sm-12 mt-2">
                  <div class="seccion_texto_">
                     Nombre cliente: {{ nombre_cliente }}
                  </div>
                  <div class="seccion_texto_">
                     NIT: {{ nit }}
                  </div>
                  <div class="seccion_texto_">
                     Serie: {{ serie }}
                  </div>
                  <div class="seccion_texto_">
                     Número: {{ numero }}
                  </div>
                  <div class="seccion_texto_">
                     Número de autorización: {{ numero_autorizacion }}
                  </div>
                  <div v-if="mostrar_info" class="seccion_texto_ mod_texto_contingencia_contenedor">
                     <div v-if="contingencia == false" class="seccion_texto_ mod_texto_contingencia_si">
                        Certificado
                     </div>
                     <div v-else class="seccion_texto_ mod_texto_contingencia_no">
                        No Certificado
                     </div>
                  </div>
                  <div v-if="contingencia && detalle_movimientos.length > 0"
                     class="seccion_texto_ mod_texto_contingencia_btn">
                     <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                        @click="certificar_contingencia">Certificar</button>
                  </div>

               </div>
               <div class="col-sm-12 mt-3">
                  <div class="marco_contingencias_certificacion">
                     <table class="table table-sm table-striped table-bordered" style="font-size: 10px;">
                        <thead>
                           <tr>
                              <th style="text-align: center;width: 15%;">
                                 Código
                              </th>
                              <th style="width: 55%;">
                                 Nombre
                              </th>
                              <th style="text-align: center;width: 10%;">
                                 Cantidad
                              </th>
                              <th style="text-align: center;width: 10%;">
                                 Precio
                              </th>
                              <th style="text-align: center;width: 10%;">
                                 Subtotal
                              </th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr v-for="(item, index) in detalle_movimientos" :key="index">
                              <td style="text-align: center;">
                                 {{ item.codigo }}
                              </td>
                              <td>
                                 {{ item.nombre_producto }}
                              </td>
                              <td style="text-align: center;">
                                 {{ Math.abs(item.cantidad) }}
                              </td>
                              <td style="text-align: center;">
                                 Q{{ item.precio.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                 }) }}
                              </td>
                              <td style="text-align: center;">
                                 Q{{ (Math.abs(item.cantidad) * item.precio).toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                 }) }}
                              </td>
                           </tr>
                        </tbody>
                     </table>
                  </div>
               </div>
            </b-row>
         </b-container>
      </div>

      <Cargando v-if="modal_cargando" titulo="Certificando..." />

   </div>
</template>

<script>
   import { minix } from '@/components/functions/alertas';
   import { mapActions, mapState } from 'vuex';
   import Cargando from '../../../Loading/Cargando.vue'

   export default {
      name: "CertificacionContingencia",
      computed: {
         ...mapState(['id_empresa_seleccionada', 'datos_usuario'])
      },
      components: {
         Cargando
      },
      data() {
         return {
            codigo: "",
            nombre_cliente: '',
            nit: '',
            serie: '',
            numero: '',
            numero_autorizacion: '',
            cta: '',
            contingencia: false,
            detalle_movimientos: [],
            mostrar_info: false,
            id_cabecera_movimiento: '',
            total_movimiento: 0,
            modal_cargando: false
         };
      },
      methods: {
         cerrar() {
            this.$emit("salir");
         },
         async registros_de_contingencias() {
            if (this.codigo != "") {

               let f = {
                  api: `movimientos-cabeceras/r/obtener-registros-de-contingencia?codigo=${this.codigo.trim()}&empresa=${this.id_empresa_seleccionada}&vendedor=${this.datos_usuario.id}&sucursal=${this.datos_usuario.sucursal_asignada}`
               }

               let r = await this.obtener_data(f)

               if (r.length == 0) {
                  minix({ icon: 'info', mensaje: 'No se encontraron registros', tiempo: 3000 })
                  document.getElementById('campo_codigo_contigencia').focus()
                  this.mostrar_info = false
                  this.id_cabecera_movimiento = ''
                  this.total_movimiento = 0
                  this.cta = ''
                  this.nombre_cliente = ''
                  this.nit = ''
                  this.serie = ''
                  this.numero = ''
                  this.numero_autorizacion = ''
                  this.detalle_movimientos = []
                  this.contingencia = false

               } else {

                  this.id_cabecera_movimiento = r.document_id
                  this.total_movimiento = r.total_movimiento
                  this.cta = r.dte
                  this.nombre_cliente = r.nombre_cliente
                  this.nit = r.nit_cliente
                  this.serie = r.sat_serie
                  this.numero = r.sat_numero
                  this.numero_autorizacion = r.sat_no_autorizacion
                  this.detalle_movimientos = r.detalle_movimiento
                  this.mostrar_info = true
                  this.contingencia = r.contingencia

               }

            } else {
               minix({ icon: 'info', mensaje: 'Indique el codigo de contigencia', tiempo: 3000 })
               document.getElementById('campo_codigo_contigencia').focus()
            }
         },
         async certificar_contingencia() {

            let f = {
               api: `movimientos-cabeceras/c/certificar-contingencias`,
               formulario: {
                  id_cabecera_movimiento: this.id_cabecera_movimiento,
                  total_movimiento: this.total_movimiento,
                  datos_contigencia: {
                     movimientos: this.detalle_movimientos,
                     nombre_cliente: this.nombre_cliente,
                     nit_cliente: this.nit,
                     empresa: this.id_empresa_seleccionada,
                     sucursal: this.datos_usuario.sucursal_asignada
                  }
               }
            }

            this.modal_cargando = true
            let rv = await this.guardar_data(f)
            this.modal_cargando = false

            if (rv === undefined) {
               console.log('Error al certificar')
            } else {
               this.cta = rv.dte
               this.nombre_cliente = rv.nombre_cliente
               this.nit = rv.nit_cliente
               this.serie = rv.sat_serie
               this.numero = rv.sat_numero
               this.numero_autorizacion = rv.sat_no_autorizacion
               this.mostrar_info = true
               this.contingencia = rv.contingencia
            }
         },
         ...mapActions(['obtener_data', 'guardar_data'])
      },
      mounted() {
         document.getElementById('campo_codigo_contigencia').focus()
      },
   };
</script>

<style>
   .mod_texto_contingencia_no {
      padding: 10px;
      background-color: red;
      color: white;
      border-radius: 4px;
   }

   .mod_texto_contingencia_si {
      padding: 10px;
      background-color: #2e8843;
      color: white;
      border-radius: 4px;
   }

   .mod_texto_contingencia_contenedor {
      position: absolute;
      top: 20px;
      right: 20px;
   }

   .marco_contingencias_certificacion {
      width: 100%;
      height: calc(100vh - 450px);
      overflow: auto;
   }

   .mod_texto_contingencia_btn {
      position: absolute;
      top: 80px;
      right: 20px;
      border-radius: 4px;
      width: 125px;
   }
</style>